{
  "titles": {
    "login": "Aanmelden"
  },
  "fields": {
    "labels": {
    "email": "E-mail",
    "password": "Wachtwoord"
  },
    "placeholders": {
      "email": "Vul je email in"
    }
  },
  "actions": {
    "login": "Inloggen"
  }
}